import React, { useState } from 'react';
import { authApi } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../components/ui/dialog';
import { Building2, Sparkles } from 'lucide-react';
import { toast } from 'sonner';

export default function CompanyNameModal({ isOpen, onComplete, userName }) {
  const [company, setCompany] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!company.trim()) {
      toast.error('Please enter your company name');
      return;
    }

    setSaving(true);
    try {
      await authApi.updateCompanyName(company.trim());
      toast.success('Welcome to Corbel! 🎉');
      onComplete(company.trim());
    } catch (error) {
      toast.error('Failed to save company name. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent className="max-w-md" hideCloseButton>
        <DialogHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="p-3 bg-orange-100 rounded-full">
              <Sparkles className="h-8 w-8 text-orange-500" />
            </div>
          </div>
          <DialogTitle className="text-center text-xl">
            Welcome{userName ? `, ${userName.split(' ')[0]}` : ''}! 🎉
          </DialogTitle>
          <DialogDescription className="text-center">
            Just one more thing - what's your company name?
          </DialogDescription>
        </DialogHeader>
        
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div>
            <Label htmlFor="company">Company Name</Label>
            <div className="relative mt-1">
              <Building2 className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
              <Input
                id="company"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                placeholder="e.g., Smith Construction LLC"
                className="pl-10 rounded-sm"
                autoFocus
                data-testid="company-name-input"
              />
            </div>
            <p className="text-xs text-muted-foreground mt-2">
              This will be shown on your client portals and documents
            </p>
          </div>
          
          <Button 
            type="submit" 
            className="w-full rounded-sm" 
            disabled={saving}
            data-testid="save-company-btn"
          >
            {saving ? 'Setting up...' : 'Get Started'}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
